<template>
  <div class="MdSep fl0"
    :class="[
      marginClass,
      hoverPath === parentPath + 'separator' ? 'on-hover' : ''
    ]"
    :style="{
      borderColor: separator.color
    }"
  >
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageSeparator } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: [],
})
export default class Separator extends Vue {
  @Prop()
  separator!: IFlexMessageSeparator

  @Prop()
  parentLayout!: string

  @Prop()
  direction!: string

  @Prop()
  parentPath!: string

  @Prop()
  hoverPath!: string

  get marginClass() {
    if (this.parentLayout === 'horizontal' || this.parentLayout === 'baseline') {
      if (this.direction === 'rtl') {
        if (this.separator.margin === 'none') {
          return 'ExMgnRNone'
        } else if (this.separator.margin === 'xs') {
          return 'ExMgnRXs'
        } else if (this.separator.margin === 'sm') {
          return 'ExMgnRSm'
        } else if (this.separator.margin === 'md') {
          return 'ExMgnRMd'
        } else if (this.separator.margin === 'lg') {
          return 'ExMgnRLg'
        } else if (this.separator.margin === 'xl') {
          return 'ExMgnRXl'
        } else if (this.separator.margin === 'xxl') {
          return 'ExMgnRXXl'
        }
      } else {
        if (this.separator.margin === 'none') {
          return 'ExMgnLNone'
        } else if (this.separator.margin === 'xs') {
          return 'ExMgnLXs'
        } else if (this.separator.margin === 'sm') {
          return 'ExMgnLSm'
        } else if (this.separator.margin === 'md') {
          return 'ExMgnLMd'
        } else if (this.separator.margin === 'lg') {
          return 'ExMgnLLg'
        } else if (this.separator.margin === 'xl') {
          return 'ExMgnLXl'
        } else if (this.separator.margin === 'xxl') {
          return 'ExMgnLXXl'
        }
      }
    } else {
      if (this.separator.margin === 'none') {
        return 'ExMgnTNone'
      } else if (this.separator.margin === 'xs') {
        return 'ExMgnTXs'
      } else if (this.separator.margin === 'sm') {
        return 'ExMgnTSm'
      } else if (this.separator.margin === 'md') {
        return 'ExMgnTMd'
      } else if (this.separator.margin === 'lg') {
        return 'ExMgnTLg'
      } else if (this.separator.margin === 'xl') {
        return 'ExMgnTXl'
      } else if (this.separator.margin === 'xxl') {
        return 'ExMgnTXXl'
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
